import React from "react";
import "../../Styles/Parentsnotification.css";


export default function Parentnotification() {
    return (
        <div className="parentnotification-container my-4">
            <div className="col-md-12">
                <div className="special-header panel-white-all  mb-4">
                    <h4 className="page-title parent-title">Parents Notification Settings</h4>
                </div>
            </div>
            <div className="row  parent-row-bg" >
               
                    <div className="panel-body">
                         <div className="col-md-12">
                        <div className="page-title ">
                            <h5>Parents Notification Settings</h5>
                        </div>
                        <div className="row">
                        <div className="col-lg-6 col-md-12">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked"  />
                                <label className="form-check-label" for="flexCheckChecked">
                                    Notification for busfares
                                </label>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked"  />
                                <label className="form-check-label" for="flexCheckChecked">
                                    Notification Related Cashless System
                                </label>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked"  />
                                <label className="form-check-label" for="flexCheckChecked">
                                    Pending Fee first reminder(parents)
                                </label>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked"  />
                                <label className="form-check-label" for="flexCheckChecked">
                                    Pending Fee second reminder(parents,class,teacher)
                                </label>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked"  />
                                <label className="form-check-label" for="flexCheckChecked">
                                    Pending Fee third reminder(parents,class teacher,accountant)
                                </label>
                            </div>
                        </div>
                     
                        <div className="update-button d-flex justify-content-end ">
                            <button className="btn custom-btn " onClick={() => alert("Well done Notification Settings saved successfully")}>
                                Update
                            </button>
                        </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
    );
}